import { render, staticRenderFns } from "./DoCanvas.vue?vue&type=template&id=6724327b"
import script from "./DoCanvas.vue?vue&type=script&lang=js"
export * from "./DoCanvas.vue?vue&type=script&lang=js"
import style0 from "./DoCanvas.vue?vue&type=style&index=0&id=6724327b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports